var UitkSheetPositionTypes = {
    LEADING: 'leading',
    TRAILING: 'trailing'
};
var UitkSideSheetColCountsMap = [
    [1, '1'],
    [2, '2'],
    [3, '3'],
    [4, '4'],
    [6, '6'],
    [8, '8'],
    [12, '12']
];
var UitkSideSheetColCounts = new Map(UitkSideSheetColCountsMap);

export { UitkSheetPositionTypes, UitkSideSheetColCounts };
